/**
 * Request persistent storage so the browser is less likely to evict IndexedDB data.
 */
export async function requestPersistentStorage(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) {
    return false
  }

  try {
    if (navigator.storage.persisted) {
      const alreadyPersisted = await navigator.storage.persisted()
      if (alreadyPersisted) return true
    }
    return await navigator.storage.persist()
  } catch (error) {
    console.warn('Persistent storage request failed:', error)
    return false
  }
}
